module.exports = __webpack_public_path__ + "static/media/sypialnia-1-min.5379909c.png";